/** Compact case toolbar — case label and session progress (navigation is in the footer). */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { plannrContactProfileUrl } from "./plannrProfile";

interface ReviewCaseHeaderProps {
  caseLabel?: string;
  plannrAccountUuid?: string | null;
  taskName?: string;
  agentName?: string;
  sessionReviewed?: number;
  sessionTotal?: number;
}

export function ReviewCaseHeader({
  caseLabel,
  plannrAccountUuid,
  taskName,
  agentName,
  sessionReviewed,
  sessionTotal,
}: ReviewCaseHeaderProps) {
  const plannrUrl = plannrAccountUuid ? plannrContactProfileUrl(plannrAccountUuid) : null;

  return (
    <header className="flex items-center gap-3 flex-wrap" data-testid="review-case-header">
      <span className="text-sm text-slate-100 font-medium truncate min-w-0 inline-flex items-center gap-2 flex-wrap">
        <span className="truncate">{caseLabel ?? "Case"}</span>
        {plannrUrl ? (
          <a
            href={plannrUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-xs font-normal text-indigo-300 hover:text-indigo-200 shrink-0"
            title="Open client profile in Plannr"
          >
            Plannr
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-[10px]" />
          </a>
        ) : null}
        {taskName ? <span className="text-slate-400 font-normal"> — {taskName}</span> : null}
      </span>

      {agentName ? (
        <>
          <span className="text-slate-600" aria-hidden>
            ·
          </span>
          <span className="text-xs text-slate-400">{agentName}</span>
        </>
      ) : null}

      <div className="flex-1" />

      {sessionTotal != null && sessionTotal > 0 ? (
        <span className="text-xs text-slate-500 tabular-nums">
          {sessionReviewed ?? 0} of {sessionTotal} reviewed
        </span>
      ) : null}
    </header>
  );
}
